export const ParamType = {
  Numeric: 'numeric',
  Character: 'character',
  Date: 'date'
};

export const QueryStatus = {
  WaitingExec: 'WaitingExec',
  Executing: 'Executing',
  ExecutedEmpty: 'ExecutedEmpty',
  Executed: 'Executed',
  Error: 'Error'
}